import { AxiosResponse } from 'axios'
import { axiosInstance } from 'axiosInstance'

import { NEWS_URLS } from 'config/urls'

import { INews, INewsMultiLang } from '../store/types'

export enum newsTypes {
    FETCH_NEWS_REQUEST = 'FETCH_NEWS_REQUEST',
    FETCH_NEWS_BY_ID = 'FETCH_NEWS_BY_ID',
    CREATE_NEWS_REQUEST = 'CREATE_NEWS_REQUEST',
    EDIT_NEWS_REQUEST = 'EDIT_NEWS_REQUEST',
    DELETE_NEWS_REQUEST = 'DELETE_NEWS_REQUEST',
    SET_NEWS = 'SET_NEWS',
    SET_ONE_PIECE_OF_NEWS = 'SET_ONE_PIECE_OF_NEWS',
    SET_RELATIVE = 'SET_REALTIVE',
}

export const getNews = ({
    language,
    appId,
    page,
}: {
    appId: string
    page: number
    language: string
}): Promise<AxiosResponse<INews[]>> =>
    axiosInstance.get(
        // eslint-disable-next-line max-len
        `${appId}${NEWS_URLS.news}/language/${language}?pageNumber=${page}&pageSize=10`,
    )

export const getNewsById = ({
    newsId,
    appId,
}: {
    newsId: string | number | undefined
    appId: string
}): Promise<AxiosResponse<INews>> =>
    axiosInstance.get(`${appId}${NEWS_URLS.news}/${newsId}`)

export const createNews = ({
    news,
    appId,
}: {
    news: INewsMultiLang[]
    appId: string
}): Promise<AxiosResponse<INews[]>> =>
    axiosInstance.post(`${appId}${NEWS_URLS.news}/bulk`, news)

export const editNews = ({
    newsId,
    news,
    appId,
}: {
    appId: string
    newsId: string
    news: INews
}): Promise<AxiosResponse<INews>> =>
    // eslint-disable-next-line max-len
    axiosInstance.put(`${appId}${NEWS_URLS.news}/${newsId}`, news)
// axiosInstance.put(`${appId}${NEWS_URLS.news}/${newsId}`, news)

export const deleteNews = ({
    newsId,
    appId,
}: {
    appId: string
    newsId: string
}): Promise<AxiosResponse<INews>> =>
    axiosInstance.delete(`${appId}${NEWS_URLS.news}/${newsId}`)
